import React from 'react'
import PropTypes from 'prop-types'
import { Button, Col, Row } from 'react-bootstrap'

function CalculatorButtons({ onClear }) {
  return (
    <Row>
      <Col xs={12} className="calculator-buttons">
        <Button bsStyle="calculator-clear" onClick={onClear}>Clear All</Button>
      </Col>
    </Row>
  )
}

CalculatorButtons.propTypes = {
  onClear: PropTypes.func,
}

export default CalculatorButtons



// WEBPACK FOOTER //
// ./src/components/CalculatorButtons/index.js